import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    data: {},
}

export const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setLayout: (state, action) => {
            state.data = action.payload
        },
    },
})


export const { setLayout } = layoutSlice.actions

export default layoutSlice.reducer;
